import { render, staticRenderFns } from "./TravelPage.vue?vue&type=template&id=5f1aa81b&scoped=true"
import script from "./TravelPage.vue?vue&type=script&lang=js"
export * from "./TravelPage.vue?vue&type=script&lang=js"
import style0 from "./TravelPage.vue?vue&type=style&index=0&id=5f1aa81b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1aa81b",
  null
  
)

export default component.exports